import { getStoryBySlug } from "@cinch-nx/data-storyblok";
import { setTag, tagError } from "@core/datadog-server";
export function getStaticPropsGenerator(path) {
    return async ({ preview =false , params  })=>{
        try {
            const slug = path === "rangeclaim" ? `${path}` : `${path}/${params === null || params === void 0 ? void 0 : params.slug}`;
            const story = await getStoryBySlug(slug, {
                version: preview ? "draft" : "published"
            });
            if (!story) {
                throw new Error("No story found for this policy page");
            }
            setTag("page.name", slug);
            setTag("page.rendered", "ISR");
            setTag("page.revalidate-in", "60s");
            setTag("page.params", JSON.stringify({
                preview
            }, null, 2));
            return {
                props: {
                    story,
                    preview,
                    layoutProps: {
                        showBorderRadius: true
                    }
                },
                revalidate: 60
            };
        } catch (error) {
            if (error instanceof Error || typeof error === "string") {
                tagError(error);
            }
            console.log(error);
            return {
                notFound: true,
                props: {
                    story: null,
                    preview,
                    layoutProps: {
                        showBorderRadius: true
                    }
                },
                revalidate: 60
            };
        }
    };
}
